var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.backCss,attrs:{"title":"返回顶部"},on:{"click":_vm.backTop}},[_c('i',{staticClass:"bi bi-arrow-up-circle"})])}
var staticRenderFns = []

export { render, staticRenderFns }